/** READ-ONLY: aktive und geplante Sales-Aktionen dieses Artikels.
 *  Pflege ausschließlich in B2B → Sales-Aktionen (Single Edit Path). */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import { ExternalLink } from "lucide-react";

export const VariantSalesPromotions = ({ variantId }) => {
  const { t, fmtDate } = useI18n();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (!variantId) return;
    api.get(`/variants/${variantId}/sales-promotions`)
      .then((r) => setRows(r.data?.entries || []))
      .catch(() => setRows([]));
  }, [variantId]);

  if (rows === null) return null;
  return (
    <div className="col-span-2 rounded-md border border-border bg-muted/30 p-3" data-testid="variant-sales-promotions">
      <div className="mb-2 flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{t("sp.inProduct")}</span>
        <Link to="/b2b" className="inline-flex items-center gap-1 text-xs text-primary hover:underline" data-testid="variant-sales-promotions-link">
          {t("sp.manageThere")} <ExternalLink className="h-3 w-3" />
        </Link>
      </div>
      {rows.length === 0 ? (
        <p className="text-xs text-muted-foreground" data-testid="variant-sales-promotions-empty">{t("sp.inProductEmpty")}</p>
      ) : (
        <div className="space-y-1.5">
          {rows.map((p) => (
            <div key={p.id} className="flex flex-wrap items-center justify-between gap-2 text-xs" data-testid={`variant-promo-${p.internal_code}`}>
              <span className="font-medium text-foreground">{p.name} <span className="font-mono text-muted-foreground">{p.internal_code}</span></span>
              <span className="text-muted-foreground">
                {p.discount_type === "percent" ? `−${p.discount_value} %` : `${Number(p.discount_value).toFixed(2).replace(".", ",")} ${p.currency}`}
                {" · "}{fmtDate(p.valid_from)} – {fmtDate(p.valid_until)}
                {" · "}<span className={p.status === "aktiv" ? "text-primary" : ""}>{t(`sp.status.${p.status}`, p.status)}</span>
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
